/**
 * Hikari Vault — Frontend Adapter
 * ================================
 * This file is the *deploy adapter* for the sandbox / preview environment.
 * It selects which app (personal | commercial) to mount based on the
 * `REACT_APP_FLAVOR` env var.
 *
 *   REACT_APP_FLAVOR=personal   → /app/apps/personal     (default — owner build)
 *   REACT_APP_FLAVOR=commercial → /app/apps/commercial   (public product)
 *
 * The actual app source lives in `apps/<flavor>/src/App.{js,jsx}`. This file
 * should stay tiny.
 */
import PersonalApp   from "@hikari/app-personal";
import CommercialApp from "@hikari/app-commercial";

const FLAVOR = (process.env.REACT_APP_FLAVOR || "personal").toLowerCase();

export default function App() {
    if (FLAVOR === "commercial") return <CommercialApp />;
    return <PersonalApp />;
}
